import React from 'react'
import Home from '../Components/Home'
import Developer from '../Components/Developer'
import Product from '../Components/Product'
import Talent from '../Components/Talent'
import FAQ from '../Components/FAQ'

const SinglePage = () => {
  return (
    <div>
      <Home/>
      <Developer/>
      <Product/>
      <Talent/>
      <FAQ/>
    </div>
  )
}

export default SinglePage